import validate from "/build_dir/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/build_dir/app/middleware/01.auth.global.ts";
import _02_45router_45global from "/build_dir/app/middleware/02.router.global.ts";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45router_45global
]
export const namedMiddleware = {
  feed: () => import("/build_dir/app/middleware/feed.ts"),
  login: () => import("/build_dir/app/middleware/login.ts"),
  mobile: () => import("/build_dir/app/middleware/mobile.ts"),
  self: () => import("/build_dir/app/middleware/self.ts"),
  timeline: () => import("/build_dir/app/middleware/timeline.ts")
}